import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { useUserInfoLoaded } from '@namespace/user';
import { GAMES_LIST_PAGE_SIZE, IS_USE_PLEX_API } from '../../constants';
import { useCategory, useGetIsLobbyDataLoaded } from '../../store';
import { useGetIsCustomCategory } from '../useGetIsCustomCategory';
import { useGetLoadFeedCategoryCallback } from '../useGetLoadFeedCategoryCallback';
import { useLoadCasinoFeed } from '../useLoadCasinoFeed';

const useLoadPlexCategory = ({
  feedNames,
  categoryId,
  casinoType,
  limit = GAMES_LIST_PAGE_SIZE,
  isSetSingleFeedCategory = false
}) => {
  const [isCategoryLoaded, setIsCategoryLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userInfoLoaded } = useUserInfoLoaded();
  const categoryFromLobby = useCategory(categoryId, feedNames, casinoType);
  const categoryFromFeed = useCategory(categoryId, feedNames);
  const isCategoryLoadedWithLobby = !isEmpty(categoryFromLobby);
  const isCategoryLoadedWithFeed = !isEmpty(categoryFromFeed?.id); // TODO: take just categoryFromFeed after fix with empty category from devel
  const isLobbyDataLoaded =
    useGetIsLobbyDataLoaded(feedNames, casinoType) && userInfoLoaded;
  const { isCustomCategory } = useGetIsCustomCategory(categoryId);
  const loadCategory = useGetLoadFeedCategoryCallback(casinoType);

  const actualIsLoaded =
    isCategoryLoaded ||
    (isLobbyDataLoaded && isCategoryLoadedWithLobby) ||
    isCategoryLoadedWithFeed;

  useEffect(() => {
    (async () => {
      if (actualIsLoaded || isLoading || !categoryId || isCustomCategory) {
        return;
      }

      setIsLoading(true);
      await loadCategory({
        feedName: feedNames,
        id: categoryId,
        filter: { offset: 0, limit },
        isSetSingleFeedCategory
      });
      setIsLoading(false);
      setIsCategoryLoaded(true);
    })();
  }, [
    feedNames,
    categoryId,
    actualIsLoaded,
    isLoading,
    isCustomCategory,
    limit,
    isSetSingleFeedCategory
  ]);

  return {
    isLoading,
    isLoaded: actualIsLoaded
  };
};

export const useLoadCategory = IS_USE_PLEX_API
  ? useLoadPlexCategory
  : useLoadCasinoFeed;
